import './css/styles.scss';

function ikonKortInit() {}

ikonKortInit();
